import { createRegionalSuburbArticles } from './councilArticleTemplate';

const sm = {
  council: 'Somerset Regional Council',
  planningScheme: 'Somerset Region Planning Scheme',
  planningUrl: 'https://www.somerset.qld.gov.au/planning-and-development/planning-scheme',
  region: 'the Somerset Region',
};

export const eskArticles = createRegionalSuburbArticles('Esk', 'esk', {
  ...sm,
  distance: '100km north-west of Brisbane, in the Somerset Region',
  keyInfra: 'Esk is the Somerset Region\'s principal town, positioned on the Brisbane Valley Highway. Lake Wivenhoe and Somerset Dam provide major waterway recreation. The town has established retail, medical, and community services. The Esk-Hampton Road connects to Toowoomba. The Brisbane Valley Rail Trail passes through Esk, attracting cycling and walking tourism.',
  zones: [
    { name: 'Township Centre (Esk)', product: 'Township retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, lifestyle' },
    { name: 'Rural', product: 'Grazing, agricultural' },
  ],
  mainStreets: 'Ipswich Street, Highland Street, Brisbane Valley Highway, and Esk-Hampton Road',
  priceRange: [
    { type: 'Standard house lot', range: '$280K - $430K' },
    { type: 'Acreage / lifestyle', range: '$400K - $800K' },
    { type: 'Rural property', range: '$500K - $1.5M+' },
  ],
  keyDriver: 'Somerset Region\'s principal town, Lake Wivenhoe and Somerset Dam recreation, Brisbane Valley Rail Trail tourism, and affordable rural lifestyle',
  uniqueFactor: 'Esk is the Somerset Region\'s major town, offering rural lifestyle with access to Lake Wivenhoe and Somerset Dam — two of SEQ\'s premier recreational waterways. The Brisbane Valley Rail Trail attracts cycling tourists, adding economic activity to the town. Esk appeals to buyers seeking affordable, scenic country living within 90 minutes of Brisbane.',
  comparison: 'Esk offers the Somerset Region\'s most complete township services with the added value of major dam recreation access.',
  nearbyAmenity: 'Lake Wivenhoe, Somerset Dam, Brisbane Valley Rail Trail, Esk town centre',
});

export const kilcoyArticles = createRegionalSuburbArticles('Kilcoy', 'kilcoy', {
  ...sm,
  distance: '100km north-west of Brisbane, in the Somerset Region',
  keyInfra: 'Kilcoy is an established rural town in the northern Somerset Region. Kilcoy has a strong agricultural economy including the historic Kilcoy meatworks. The town provides retail, medical, and community services. Lake Somerset is nearby for recreation. The D\'Aguilar Highway provides road connectivity to Brisbane via Caboolture.',
  zones: [
    { name: 'Township Centre (Kilcoy)', product: 'Township retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, pastoral' },
    { name: 'Rural', product: 'Agricultural, grazing' },
  ],
  mainStreets: 'Hope Street, William Street, Mary Street, and D\'Aguilar Highway',
  priceRange: [
    { type: 'Standard house lot', range: '$260K - $400K' },
    { type: 'Acreage / lifestyle', range: '$380K - $750K' },
    { type: 'Rural property', range: '$500K - $1.5M+' },
  ],
  keyDriver: 'Established rural town with agricultural economy, Lake Somerset recreation, D\'Aguilar Highway access to Caboolture and Brisbane, and affordable country living',
  uniqueFactor: 'Kilcoy is a genuine country town with a strong agricultural identity. The meatworks and pastoral economy provide local employment. Lake Somerset is nearby for waterway recreation. Affordable property prices attract retirees and lifestyle buyers seeking authentic rural character.',
  comparison: 'Kilcoy offers the most affordable township living in the northern Somerset Region with established services and rural character.',
  nearbyAmenity: 'Kilcoy town centre, Lake Somerset (nearby), D\'Aguilar Highway, agricultural surrounds',
});

export const fernvaleArticles = createRegionalSuburbArticles('Fernvale', 'fernvale', {
  ...sm,
  distance: '60km west of Brisbane, at the gateway to the Somerset Region',
  keyInfra: 'Fernvale is the gateway to the Somerset Region from Brisbane and Ipswich. The Brisbane Valley Highway provides connectivity. Fernvale has experienced significant residential growth with new estates. Local retail and services are expanding. Lake Wivenhoe is accessible for recreation. Fernvale Futures is a planned growth area.',
  zones: [
    { name: 'Township Centre (Fernvale)', product: 'Local retail + residential' },
    { name: 'Low-Medium Density Residential', product: 'Townhouses, new estate homes' },
    { name: 'Low Density Residential', product: 'Houses, new estates' },
    { name: 'Emerging Community', product: 'New residential development' },
  ],
  mainStreets: 'Brisbane Valley Highway, Queen Street, Main Street, and Banks Creek Road',
  priceRange: [
    { type: 'Standard house lot', range: '$350K - $530K' },
    { type: 'New estate lot', range: '$380K - $560K' },
    { type: 'Acreage / lifestyle', range: '$500K - $900K' },
  ],
  keyDriver: 'Gateway positioning to Somerset Region, residential growth from new estates, affordable housing for Brisbane/Ipswich commuters, and Lake Wivenhoe recreation access',
  uniqueFactor: 'Fernvale is the Somerset Region\'s fastest-growing area — a gateway town experiencing significant residential development as Brisbane and Ipswich commuters seek affordable housing. New estates are transforming the town from a rural village into a suburban-fringe community while maintaining its country character.',
  comparison: 'Fernvale is the Somerset\'s most accessible growth area and closest to Brisbane employment. Growth momentum makes it the region\'s strongest property market.',
  nearbyAmenity: 'Fernvale township, Lake Wivenhoe (nearby), Brisbane Valley Highway, new residential estates',
});

export const lowoodArticles = createRegionalSuburbArticles('Lowood', 'lowood', {
  ...sm,
  distance: '65km west of Brisbane, in the Somerset Region',
  keyInfra: 'Lowood is a township on the Brisbane Valley Highway between Fernvale and Esk. The town has established retail and community services. The Brisbane River is adjacent, providing waterway amenity. Lowood State High School serves the community. The town has an agricultural heritage with surrounding farmland.',
  zones: [
    { name: 'Township Centre (Lowood)', product: 'Township retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, lifestyle' },
    { name: 'Rural', product: 'Agricultural, river flats' },
  ],
  mainStreets: 'Main Street, Prospect Street, Brisbane Valley Highway, and Clarendon Road',
  priceRange: [
    { type: 'Standard house lot', range: '$300K - $460K' },
    { type: 'Acreage / lifestyle', range: '$420K - $780K' },
    { type: 'Rural / riverfront', range: '$500K - $1.2M+' },
  ],
  keyDriver: 'Brisbane River amenity, affordable country town living, Brisbane Valley Highway access, and growing residential demand from Ipswich commuters',
  uniqueFactor: 'Lowood is a friendly Brisbane Valley township with Brisbane River frontage and established community services. Affordable property prices and improving connectivity to Ipswich and Brisbane are attracting buyers seeking rural lifestyle at accessible pricing.',
  comparison: 'Lowood offers genuine country town living with river amenity at very affordable pricing. Proximity to Fernvale\'s growth supports increasing property interest.',
  nearbyAmenity: 'Lowood township, Brisbane River, Brisbane Valley Highway, Lowood State High School',
});

export const toogoolawahArticles = createRegionalSuburbArticles('Toogoolawah', 'toogoolawah', {
  ...sm,
  distance: '110km north-west of Brisbane, in the Somerset Region',
  keyInfra: 'Toogoolawah is a heritage township on the Brisbane Valley Highway north of Esk. The town has a charming main street with heritage buildings. Cressbrook Creek provides waterway amenity. The Brisbane Valley Rail Trail passes through the town. Skydiving at the Toogoolawah airfield attracts adventure tourism.',
  zones: [
    { name: 'Township Centre (Toogoolawah)', product: 'Heritage township retail + residential' },
    { name: 'Low Density Residential', product: 'Houses' },
    { name: 'Rural Residential', product: 'Acreage, pastoral lifestyle' },
    { name: 'Rural', product: 'Grazing, pastoral' },
  ],
  mainStreets: 'Cressbrook Street, McConnell Street, Livingstone Street, and Brisbane Valley Highway',
  priceRange: [
    { type: 'Standard house lot', range: '$240K - $380K' },
    { type: 'Acreage / lifestyle', range: '$350K - $700K' },
    { type: 'Rural property', range: '$450K - $1.2M+' },
  ],
  keyDriver: 'Heritage township character, Brisbane Valley Rail Trail tourism, skydiving tourism, ultra-affordable housing, and quiet pastoral lifestyle',
  uniqueFactor: 'Toogoolawah is one of SEQ\'s most charming heritage townships, offering ultra-affordable rural living in a scenic Brisbane Valley setting. The Rail Trail and skydiving tourism add economic activity. The town appeals to retirees, tree-changers, and adventure tourism operators seeking affordable character properties.',
  comparison: 'Toogoolawah offers some of the most affordable property in South East Queensland with genuine heritage township character.',
  nearbyAmenity: 'Heritage main street, Cressbrook Creek, Brisbane Valley Rail Trail, Toogoolawah airfield (skydiving)',
});
